import { init_gradient_table, natural_sort, round } from 'amt_admin/utils';


export default function(app) {
    app.component('installsTable', {
        template: require('./template.html'),
        bindings: {
            getPlayers: '@?',
            prec: '@?',
            rows: '<',
            tooltips: '<?',
            columnNames: '<?',
            rebuildColumnsOnChange: '<?',
        },
        controllerAs: 'vm',
        controller: function() {
            const prec = this.prec || 2;
            const table = init_gradient_table();
            this.get_bg_color = table.get_bg_color;
            this.fix_number = (value) => value === -1 ? '-' : round(value, prec);
            this.columnNames = this.columnNames || [];
            this.rows = this.rows || [];
            this.rebuildColumnsOnChange = this.rebuildColumnsOnChange || false;
            this.$onChanges = (changesObj) => {
                const rows = (changesObj.rows.currentValue || []).map(row => row.columns);
                table.set_rows(rows);
                if ((this.columnNames.length === 0 || this.rebuildColumnsOnChange) && rows.length > 0) {
                    this.columnNames = natural_sort(Object.keys(rows[0]));
                }
            };
        },
    });
};
